<div class="title">SIGN IN TO YOUR ACCOUNT</div>

<form name="loginForm" [formGroup]="loginForm" (ngSubmit)="onFormSubmit(loginForm.value)" novalidate>

    <mat-form-field>
        <input matInput
               placeholder="Email"
               formControlName="username"
               name="username"
               id="username-input"
               ngcAutofocus
        >
        <mat-error *ngIf="loginFormErrors?.username?.required">
            Email is required
        </mat-error>
    </mat-form-field>

    <mat-form-field>
        <input type="password"
               matInput
               placeholder="Password"
               formControlName="password"
               name="password"
               id="password-input"
        >
        <mat-error *ngIf="loginFormErrors?.password?.required">
            Password is required
        </mat-error>
    </mat-form-field>

    <div class="remember-forgot-password"
         fxLayout="row" fxLayout.xs="column"
         fxLayoutAlign="space-between center"
    >
        <!--<mat-checkbox class="remember-me" aria-label="Remember Me">
            Remember Me
        </mat-checkbox>-->

        <a class="forgot-password"
           id="forgot-password-link"
           [routerLink]="'/auth/forgot-password'"
        >
            Forgot Password?
        </a>
    </div>

    <button mat-raised-button color="accent"
            id="log-in-button"
            class="submit-button"
            aria-label="Sign in"
            [disabled]="(loading$ | async)">
        Sign in
    </button>
</form>

<div fxLayout="row"
     fxLayoutAlign="center center"
     *ngIf="hasStsServer"
>
    <a *ngIf="isDistrictLogin"
       class="district-admin-login-link"
       (click)="loginAsVendorAdmin()"
       href="/login/vendor"
    >
        Sign in as Vendor
    </a>
    <a *ngIf="!isDistrictLogin"
       class="district-admin-login-link"
       (click)="loginAsDistrictAdmin()"
       [href]="hasStsServer ? '' : '/login/district'"
    >
        Sign in as District Admin
    </a>
</div>

<!--<div fxLayout="row"-->
<!--     fxLayoutAlign="center center"-->
<!--&gt;-->
<!--    <a class="contact-link"-->
<!--       [href]="supportUrl"-->
<!--    >-->
<!--        Contact Support-->
<!--    </a>-->
<!--</div>-->
